import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { LoginComponent } from '../login/login.component';
import { CallComponent } from '../../actions/call/call.component';
import { AppComponent } from '../../app.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusinessEventService } from '../../services/business-event.service';
var HeaderComponent = (function () {
    function HeaderComponent(_data, _utils, _bevent, _blogic) {
        this._data = _data;
        this._utils = _utils;
        this._bevent = _bevent;
        this._blogic = _blogic;
        this.isCallLoading = false;
        this.destroy$ = new Subject();
        this.turn = null;
        this.selectedTurn = null;
        this.user = "";
        this.password = "";
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._utils.initializeTooltip();
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
        this._data.selectedTurnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._selectedUpdateTurn(response);
        });
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Logout and close actual turn */
    HeaderComponent.prototype.logout = function () {
        this._utils.localStorage("delete", "session");
        var params = {
            login: this._data.session["operator"],
            desk_id: this._data.session["desk"]
        };
        this._blogic.logout()
            .pipe(takeUntil(this.destroy$))
            .subscribe();
        window.location.reload();
        if (this._data.turn != null) {
            this._close();
        }
    };
    /* When the turn information change */
    HeaderComponent.prototype._updateTurn = function (turn) {
        this.turn = this._data.turn;
    };
    /* Close current turn */
    HeaderComponent.prototype._close = function () {
        var params = {
            desk_id: this._data.session["desk"],
            status: "I",
            turn_id: this._data.turn["id"],
            ticket: this._data.turn["num"],
            label: this._data.turn["label"],
            queue_id: this._data.turn["queue_id"],
            session_id: this._data.session["session"],
            kind_id: this._data.session["category"],
            deskuser: this._data.session["username"],
            deskoperator: this._data.session["operator"]
        };
        this._blogic.deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe();
    };
    /* When the turn information change */
    HeaderComponent.prototype._selectedUpdateTurn = function (selectedTurn) {
        this.selectedTurn = selectedTurn;
    };
    /* User grant configuration */
    HeaderComponent.prototype.configurationGrant = function () {
        var grant = this._data.session["grant"];
        return grant.mesa.config;
    };
    HeaderComponent.prototype.login = function () {
        this._bevent.close();
        var credentials = {
            desk_id: parseInt(this._data.session["desk"]),
            username: this.user,
            pwd: this.password
        };
        this.loginComponent.doLogin(credentials, false, false);
        this.user = "";
        this.password = "";
    };
    HeaderComponent.prototype.callLoading = function (event) {
        this.isCallLoading = event;
    };
    HeaderComponent.prototype.shouldShowDeskId = function () {
        return this._data.json_config &&
            this._data.json_config.showdeskid === true;
    };
    HeaderComponent.prototype.shouldShowOfficeId = function () {
        return this._data.json_config &&
            this._data.json_config.showofficeid === true;
    };
    return HeaderComponent;
}());
export { HeaderComponent };
